import { BrainCircuit, Cog, Headset } from "lucide-react";
import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";

const schoolBenefits = [{
    icon: <Headset className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Proactive Support",
    description: "Fixes problems before they hurt learning.",
}, {
    icon: <BrainCircuit className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Human-aware AI",
    description: "Empathetic, stress-free automation.",
}, {
    icon: <Cog className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Transparent Operations",
    description: "You can see every action and change.",
}];


export default function WhySchoolLoveUs() {

    return (
        <Box
            badge={"WHY US"}
            title={"Why Schools Love Us"}
            leftBlock={
                <div className='col-span-2 md:col-span-1'>
                    <div className="grid grid-cols-3 md:grid-cols-1 gap-6">
                        {schoolBenefits.slice(0, 3).map((member, index) => <MarktingCard key={"memberasdsadInnerCard" + index} member={member} />)}
                    </div>
                </div>
            }
        />
    );
}